/* eslint-disable import/prefer-default-export */
import $ from 'jquery'

export function sliders() {
  $('.review__slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    appendArrows: '.review__bottom',
    accessibility: false,
    prevArrow: '<div class="main-arrow prev-arrow"><svg width="10" height="17" viewBox="0 0 16 25" xmlns="http://www.w3.org/2000/svg"><path  d="M13.558 24.7589L14.7633 23.5574C15.0659 23.2764 15.0827 22.8005 14.8024 22.497C14.7898 22.4833 14.7771 22.4709 14.7633 22.4559L5.30473 12.9973L14.7633 3.55377C15.0686 3.26203 15.0827 2.77598 14.7926 2.46696C14.7827 2.45784 14.7729 2.44741 14.7633 2.43729L13.558 1.23673C13.4094 1.0884 13.2089 1.00202 12.9974 0.998756C12.7913 0.998756 12.5924 1.08645 12.4509 1.23673V1.23868L1.22777 12.4481C0.926684 12.7291 0.908378 13.205 1.18875 13.5101C1.20135 13.5222 1.21382 13.5365 1.22777 13.5495L12.4509 24.7589C12.5924 24.9115 12.7913 24.9976 12.9974 24.9989C13.2089 24.9946 13.4094 24.9086 13.558 24.7589Z"/></svg></div>',
    nextArrow: '<div class="main-arrow next-arrow"><svg width="10" height="17" viewBox="0 0 16 24" xmlns="http://www.w3.org/2000/svg"><path d="M2.44167 0.240299L1.23637 1.44218C0.933794 1.72287 0.916982 2.19877 1.19724 2.50228C1.20995 2.51629 1.22253 2.52868 1.23637 2.54334L10.6949 12.0019L1.23637 21.4455C0.931058 21.7372 0.916982 22.2233 1.20709 22.5323C1.21693 22.5411 1.22676 22.5519 1.23637 22.562L2.44167 23.7625C2.59023 23.9108 2.79071 23.9976 3.00221 24.0005C3.20831 24.0005 3.40721 23.9131 3.54878 23.7625V23.7606L14.7719 12.5512C15.073 12.2705 15.0913 11.7946 14.811 11.4891C14.7983 11.4771 14.786 11.4627 14.7719 11.45L3.54878 0.240299C3.40721 0.088073 3.20831 0.00202405 3.00221 5.30481e-05C2.79071 0.00494003 2.59023 0.090692 2.44167 0.240299Z" /></svg></div>',
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  if ($(window).width() < 767) {
    $('.add-news .news').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: false,
      arrows: false,
      dots: true
    });
  }
  $('.calculation__slider').slick({
    infinite: true,
    slidesToShow: 1,
    fade: true,
    slidesToScroll: 1,
    accessibility: false,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.awards').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    accessibility: false,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  //
  // $('.custom-1 .education__slider').slick({
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   accessibility: false,
  //   arrows: false,
  //   fade: true,
  //   asNavFor: '.custom-1 .education__slider-image'
  // });

  $('.certificates-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    accessibility: false,
    dots: true,
    arrows: true,
    centerMode: true,
    variableWidth: true,
    rows: 0,
    focusOnSelect: true,
    prevArrow: '<div class="main-arrow prev-arrow"><svg width="10" height="17" viewBox="0 0 16 25" xmlns="http://www.w3.org/2000/svg"><path  d="M13.558 24.7589L14.7633 23.5574C15.0659 23.2764 15.0827 22.8005 14.8024 22.497C14.7898 22.4833 14.7771 22.4709 14.7633 22.4559L5.30473 12.9973L14.7633 3.55377C15.0686 3.26203 15.0827 2.77598 14.7926 2.46696C14.7827 2.45784 14.7729 2.44741 14.7633 2.43729L13.558 1.23673C13.4094 1.0884 13.2089 1.00202 12.9974 0.998756C12.7913 0.998756 12.5924 1.08645 12.4509 1.23673V1.23868L1.22777 12.4481C0.926684 12.7291 0.908378 13.205 1.18875 13.5101C1.20135 13.5222 1.21382 13.5365 1.22777 13.5495L12.4509 24.7589C12.5924 24.9115 12.7913 24.9976 12.9974 24.9989C13.2089 24.9946 13.4094 24.9086 13.558 24.7589Z"/></svg></div>',
    nextArrow: '<div class="main-arrow next-arrow"><svg width="10" height="17" viewBox="0 0 16 24" xmlns="http://www.w3.org/2000/svg"><path d="M2.44167 0.240299L1.23637 1.44218C0.933794 1.72287 0.916982 2.19877 1.19724 2.50228C1.20995 2.51629 1.22253 2.52868 1.23637 2.54334L10.6949 12.0019L1.23637 21.4455C0.931058 21.7372 0.916982 22.2233 1.20709 22.5323C1.21693 22.5411 1.22676 22.5519 1.23637 22.562L2.44167 23.7625C2.59023 23.9108 2.79071 23.9976 3.00221 24.0005C3.20831 24.0005 3.40721 23.9131 3.54878 23.7625V23.7606L14.7719 12.5512C15.073 12.2705 15.0913 11.7946 14.811 11.4891C14.7983 11.4771 14.786 11.4627 14.7719 11.45L3.54878 0.240299C3.40721 0.088073 3.20831 0.00202405 3.00221 5.30481e-05C2.79071 0.00494003 2.59023 0.090692 2.44167 0.240299Z" /></svg></div>',
  });

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js